export default "__VITE_ASSET__CePiXtTi__"